import { render, staticRenderFns } from "./clickShow.vue?vue&type=template&id=1ce7ff76"
import script from "./clickShow.vue?vue&type=script&lang=js"
export * from "./clickShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports